import React from 'react';
import styled from 'styled-components';

const EQKnobWrapper = styled.div`
    position: relative;
    width: ${props => props.knobSize || 30}px;
    height: ${props => props.knobSize || 30}px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const EQKnobScale = styled.div`
    position: absolute;
    top: ${props => -(props.scaleSize - props.knobSize) / 2}px;
    left: ${props => -(props.scaleSize - props.knobSize) / 2}px;
    width: ${props => props.scaleSize || 50}px;
    height: ${props => props.scaleSize || 50}px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
`;

const EQKnobTick = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${props => props.tickWidth || 1.5}px;
    height: ${props => props.tickHeight || 5}px;
    background: rgba(100, 100, 100, 0.6);
    transform-origin: center;
    transform: translate(-50%, -50%) rotate(${props => props.angle}deg) translateY(${props => -(props.scaleSize || 50) / 2 + 5}px);
    border-radius: 0.5px;
    pointer-events: none;
`;

const EQKnob = styled.div`
    width: ${props => props.knobSize || 30}px;
    height: ${props => props.knobSize || 30}px;
    min-width: ${props => props.knobSize || 30}px;
    min-height: ${props => props.knobSize || 30}px;
    max-width: ${props => props.knobSize || 30}px;
    max-height: ${props => props.knobSize || 30}px;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #3a3a3a 0%, #1a1a1a 100%);
    border: ${props => props.borderWidth || 2}px solid rgba(244, 212, 163, 0.3);
    box-shadow: 
        inset 0 2px 5px rgba(0, 0, 0, 0.5),
        0 2px 8px rgba(0, 0, 0, 0.3);
    position: relative;
    cursor: grab;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    transform: rotate(${props => props.rotation || 0}deg);
    z-index: 2;
    flex-shrink: 0;

    &::before {
        content: '';
        position: absolute;
        top: ${props => (props.knobSize || 30) * 0.1}px;
        left: 50%;
        transform: translateX(-50%);
        width: ${props => (props.knobSize || 30) * 0.067}px;
        height: ${props => (props.knobSize || 30) * 0.267}px;
        background: rgba(244, 212, 163, 0.8);
        border-radius: 2px;
    }
`;

export const EQSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
`;

export const EQLabel = styled.div`
    font-size: 0.7rem;
    color: rgba(244, 212, 163, 0.7);
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
`;

// EQ 旋钮组件（包含刻度标记）
const EQKnobWithScale = ({ type, rotation, onMouseDown, onTouchStart, onClick, knobSize, scaleSize, tickWidth, tickHeight, borderWidth }) => {
    return (
        <EQKnobWrapper knobSize={knobSize}>
            <EQKnobScale scaleSize={scaleSize} knobSize={knobSize}>
                {Array.from({ length: 11 }, (_, i) => {
                    // 从 150 度到 -60 度，逆时针方向，11 个刻度
                    // 150 度开始，每个间隔 30 度递减
                    const angle = 150 - (i * 30);
                    return (
                        <EQKnobTick 
                            key={i} 
                            angle={angle}
                            scaleSize={scaleSize}
                            tickWidth={tickWidth}
                            tickHeight={tickHeight}
                        />
                    );
                })}
            </EQKnobScale>
            <EQKnob 
                data-eq-knob={type}
                rotation={rotation}
                onMouseDown={onMouseDown}
                onTouchStart={onTouchStart}
                onClick={onClick}
                knobSize={knobSize}
                borderWidth={borderWidth}
            />
        </EQKnobWrapper>
    );
};

export default EQKnobWithScale;

